import React, { Component } from "react";
import MediaQuery from "react-responsive";
import BootstrapTable from "react-bootstrap-table-next";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "../../../services/axios-service";
import { connect } from "react-redux";

import CandidateProgressIcon from "../../../assets/images/candidate-progress.png";
import CandidateRegretIcon from "../../../assets/images/candidate-regret.png";
import CandidateUnsortedIcon from "../../../assets/images/candidate-unsorted.svg";
import DashboardBar from "../../../components/Recruiter/DashboardBar/DashboardBar";
import ExpandedRow from "../../../components/Recruiter/ExpandedRow/ExpandedRow";
import "./RecruiterJobReport.css";
import dashboardlogo from "../../../assets/images/dashboard-logo.svg";
import Button from "../../../components/UI/Button/Button";
import Icon from "../../../components/UI/Icon/Icon";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";

/**
 * @desc List candidate under specific job- desktop view
 * @param props
 * @return DOMElement
 */
const CandidateRowDesktop = props => {
  return (
    <tr>
      <td className="date-added">{props.dateAdded}</td>
      <td className="bullhorn-id">{props.bullhornID}</td>
      <td className="name">{props.name}</td>
      <td className="status">
        <CandidateStatus status={props.status} />
      </td>
      <td className="current-status">{props.currentStatus}</td>
      <td className="email">{props.email}</td>
      <td className="action">
        <Icon
          icon={
            props.status == "PENDING"
              ? "dropdown-arrow-disabled"
              : "dropdown-arrow"
          }
          className=""
        />
      </td>
    </tr>
  );
};

/**
 * @desc List candidate under specific job- Mobile view
 * @param props
 * @return DOMElement
 */
const CandidateRowMobile = props => {
  return (
    <tr>
      <td className="bullhorn-id"> {props.bullhornID}</td>
      <td className="name">
        <div>{props.name}</div>
        <div className="current-status">{props.currentStatus}</div>
      </td>
      <td className="status">
        <CandidateStatus status={props.status} />
      </td>
    </tr>
  );
};

/**
 * @desc show candidate status
 * @param props
 * @return DOMElement
 */
const CandidateStatus = props => {
  let statusIconImage = null;
  let statusText = "";
  if (props.status === "PROGRESS") {
    statusIconImage = CandidateProgressIcon;
    statusText = "Progress";
  } else if (props.status === "REGRET") {
    statusIconImage = CandidateRegretIcon;
    statusText = "Regret";
  } else {
    statusIconImage = CandidateUnsortedIcon;
    statusText = "Unsorted";
  }

  return (
    <div className="candidate-status">
      <span className="status__text">{statusText}</span>{" "}
      <StatusIcon icon={statusIconImage} />
    </div>
  );
};

/**
 * @desc show candidate status
 * @param props
 * @return DOMElement
 */
const ReviewStatus = props => {
  let reviewsStatusText = "";
  if (props.reviewStatus === "COMPLETE") {
    reviewsStatusText = "Completed";
  } else if (props.reviewStatus === "SENT") {
    reviewsStatusText = "Sent";
  } else if (props.reviewStatus === "VIEWED") {
    reviewsStatusText = "Viewed";
  } else {
    reviewsStatusText = "";
  }

  return (
    <div className="review-status">
      <span className={reviewsStatusText}>{reviewsStatusText}</span>
    </div>
  );
};
/**
 * @desc show candidate status-icon
 * @param props
 * @return DOMElement
 */
const StatusIcon = props => {
  if (props.icon) {
    return <img className="status-icon unsorted" src={props.icon} />;
  } else {
    return "";
  }
};

const CandidateNameMobile = props => {
  return (
    <div>
      <span className="pool-candidate-list candidateName">
        {props.candidateName}
      </span>
      <br />
      <span className="pool-candidate-list currentJobTitle">
        {props.currentJobTitle}
      </span>
    </div>
  );
};

/**
 * @desc shows candidate list to particular jobtitles added by recruiter
 * @version 0.1.0
 * @author Amrutha K K,LakshmiKanth,Praveen George
 */
class RecruiterJobReport extends Component {
  constructor() {
    super();
    this.state = {
      candidates: [],
      candidateScoring: [],
      activeCandidateId: "",
      expanded: [],
      feedbackHistory: []
    };
  }
  componentDidMount() {
    axios
      .get("/galaxy/job/" + this.props.match.params.id + "/candidate")
      .then(response => {
        this.setState({ candidates: response.data.items });
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  }

  handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      if (this.props.location.state.company_type !== 1) {
        this.getEvaluationHistory(row.Id);
      }
      this.setState(() => ({
        expanded: [row.keyId]
      }));
    } else {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== row.keyId)
      }));
    }
  };

  getEvaluationHistory = candidateId => {
    axios
      .get(
        "/galaxy/job/" +
          this.props.match.params.id +
          "/candidate/" +
          candidateId +
          "/history"
      )
      .then(response => {
        if (response.data) {
          this.setState({ feedbackHistory: response.data });
        }
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  render() {
    const candidates = this.state.candidates;
    const jobId = this.props.match.params.id;
    const locationState = this.props.location.state.jobTitle;
    const jobBH = this.props.location.state.jobBH;
    const companyType = this.props.location.state.company_type;

    const columns = [
      {
        dataField: "reviewStatus",
        text: ""
      },
      {
        dataField: "dateAdded",
        text: "Date Added"
      },
      {
        dataField: "bullhornID",
        text: "Bullhorn ID"
      },
      {
        dataField: "name",
        text: "Name"
      },
      {
        dataField: "status",
        text: "Status"
      },
      {
        dataField: "currentStatus",
        text: "Current Job"
      },
      {
        dataField: "email",
        text: "Email"
      },
      {
        dataField: "scoring",
        text: companyType === 1 ? "Scoring" : "Feedback"
      }
    ];
    const mobileColumns = [
      {
        dataField: "reviewStatus",
        text: ""
      },

      {
        dataField: "bullhornID",
        text: "Bullhorn ID"
      },
      {
        dataField: "name",
        text: "Name"
      },
      {
        dataField: "status",
        text: "Status"
      },

      {
        dataField: "scoring",
        text: companyType === 1 ? "Scoring" : ""
      }
    ];

    const products =
      candidates.message || candidates.length === 0
        ? []
        : candidates.map((candidate, index) => {
            return {
              reviewStatus: (
                <ReviewStatus reviewStatus={candidate.review_status} />
              ),
              keyId: index,
              scoringData: JSON.parse(candidate.candidate_scoring)
                ? JSON.parse(candidate.candidate_scoring)
                : "",
              scoreValue: candidate.candidate_score,
              candidateStatus: candidate.candidate_status,
              regretReason: candidate.regret_reason,
              Id: candidate.candidate_id,
              dateAdded: new Date(candidate.candidate_added_date)
                .toISOString()
                .replace(/T.*/, "")
                .split("-")
                .reverse()
                .join("/"),
              bullhornID: candidate.candidate_source_id,
              name: candidate.candidate_fname + " " + candidate.candidate_lname,
              status: <CandidateStatus status={candidate.candidate_status} />,
              currentStatus:
                candidate.current_job_title !== null &&
                candidate.current_job_title.trim() !== ""
                  ? candidate.current_job_title
                  : "Actively Seeking Employment",
              email: candidate.email,
              nonExpandable:
                candidate.candidate_status == "PENDING" ? index : "",
              scoring: (
                <Icon
                  icon={
                    candidate.candidate_status == "PENDING"
                      ? "dropdown-arrow-disabled"
                      : this.state.expanded[0] !== index
                      ? "dropdown-arrow"
                      : "up-arrow"
                  }
                  className=""
                />
              ),
              scoredBy: candidate.scored_by,
              clientFeedback: candidate.client_feedback,
              sortedDate: candidate.sorted_dt,
              companyType: this.props.location.state.company_type,
              feedbackHistory: this.state.feedbackHistory
            };
          });

    const nonExpandables = products
      .filter(nonExpandable => nonExpandable.nonExpandable !== "")
      .map((nonExpandable, index) => {
        return nonExpandable.keyId;
      });

    const productsMobile =
      candidates.message || candidates.length === 0
        ? []
        : candidates.map((candidate, index) => {
            return {
              reviewStatus: (
                <ReviewStatus reviewStatus={candidate.review_status} />
              ),
              keyId: index,
              scoringData: JSON.parse(candidate.candidate_scoring)
                ? JSON.parse(candidate.candidate_scoring)
                : "",
              scoreValue: candidate.candidate_score,
              candidateStatus: candidate.candidate_status,
              regretReason: candidate.regret_reason,
              Id: candidate.candidate_id,
              bullhornID: candidate.candidate_source_id,
              name: (
                <CandidateNameMobile
                  candidateName={
                    candidate.candidate_fname + " " + candidate.candidate_lname
                  }
                  currentJobTitle={
                    candidate.current_job_title !== null &&
                    candidate.current_job_title.trim() !== ""
                      ? candidate.current_job_title
                      : "Actively Seeking Employment"
                  }
                />
              ),
              status: <CandidateStatus status={candidate.candidate_status} />,
              nonExpandable:
                candidate.candidate_status == "PENDING" ? index : "",
              scoring: (
                <Icon
                  icon={
                    candidate.candidate_status == "PENDING"
                      ? "disabled-down-arrow-small"
                      : this.state.expanded[0] !== index
                      ? "dropdown-arrow-small"
                      : "up-arrow-small"
                  }
                  className=""
                />
              ),
              scoredBy: candidate.scored_by,
              clientFeedback: candidate.client_feedback,
              sortedDate: candidate.sorted_dt,
              companyType: this.props.location.state.company_type,
              feedbackHistory: this.state.feedbackHistory
            };
          });

    const expandRow = {
      renderer: row => (
        <ExpandedRow
          {...row}
          scoring={row.scoringData}
          scoreValue={row.scoreValue}
          candidateStatus={row.candidateStatus}
          regretReason={row.regretReason}
          scoredBy={row.scoredBy}
          companyType={row.companyType}
          sortedDate={row.sortedDate}
          clientFeedback={row.clientFeedback}
          feedbackHistory={row.feedbackHistory}
        />
      ),
      onExpand: this.handleOnExpand,
      expanded: this.state.expanded,
      nonExpandable: nonExpandables
    };

    return (
      <div>
        {/* Desktop View Section starts */}
        <MediaQuery query="(min-device-width: 769px)">
          <DashboardBar activeLink="view-all-jobs" />
        </MediaQuery>
        {/* Desktop View Section Ends */}
        <div className="dashboard-nav-header-mobile">
          {/* Mobile View Section starts */}
          <MediaQuery query="(max-device-width: 769px)">
            {/* <Link className="dashboardlogo" to="/recruiter/dashboard">
              <img className="img-responsive dashboard-nav-logo-mobile" src={dashboardlogo} alt="logo"/>
            </Link> */}
            <Icon
              icon="left-arrow"
              className="recruiter-back-icon "
              onClick={() => window.history.back()}
            />
            <h1 className="pool-candidate-list-title">
              {locationState} - {jobBH}
            </h1>
          </MediaQuery>
          {/* Mobile View Section Ends */}
        </div>

        {/* Desktop View Section starts */}
        <MediaQuery query="(min-device-width: 769px)">
          <div className="pool-candidate-list-title-cont">
            <h1 className="pool-candidate-list-title">
              Candidate list for {locationState} - {jobBH}
            </h1>
            {this.state.candidates.message ? (
              ""
            ) : (
              <p>Please see client decisions on candidates below.</p>
            )}
          </div>
        </MediaQuery>
        {/* Desktop View Section Ends */}

        {this.state.candidates.message ? (
          <div>
            <div className="no-candidates-description">
              <p>No candidates have been added to this job </p>
            </div>
            <div className="null-jobs-report-prev-button">
              <div className="null-stepper-previous-button">
                <Button
                  onClick={() => window.history.back()}
                  size="small"
                  className="joblist-previous-button"
                  buttonicon="previous-icon"
                />
              </div>
            </div>
          </div>
        ) : (
          <div
            className={
              companyType === 1
                ? "pool-candidate-list score"
                : "pool-candidate-list feedback-section"
            }
          >
            <MediaQuery query="(max-device-width: 767px)">
              <BootstrapTable
                striped
                hover
                keyField="keyId"
                data={productsMobile}
                columns={mobileColumns}
                expandRow={expandRow}
              />
            </MediaQuery>

            <MediaQuery query="(min-device-width: 768px)">
              <BootstrapTable
                striped
                hover
                keyField="keyId"
                data={products}
                columns={columns}
                expandRow={expandRow}
              />
              <div className="jobs-report-prev-button">
                <div className="stepper-previous-button">
                  <Button
                    onClick={() => window.history.back()}
                    size="small"
                    className="joblist-previous-button"
                    buttonicon="previous-icon"
                  />
                </div>
              </div>
            </MediaQuery>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  recruiterDetails: state.clientProfile.clientDetails
});

export default connect(
  mapStateToProps,
  null
)(withErrorHandler(RecruiterJobReport, axios));



// WEBPACK FOOTER //
// ./src/container/Recruiter/RecruiterJobReport/RecruiterJobReport.js